import React, { Component } from 'react';
import PropTypes from 'prop-types';
import T from "i18n-react/dist/i18n-react";

class Counter extends Component {
	constructor(props){
		super(props);
		this.state = { value: this.props.productQuantity };
		this.increment = this.increment.bind(this);
		this.decrement = this.decrement.bind(this);
	}

	increment = (e) => {
		if (this.state.value < this.props.productAvail) {
            this.setState(prevState => ({
                value: Number(prevState.value) + 1
            }), function() {
                this.props.updateQuantity(this.state.value);
            });
		} else {
			alert(T.translate("labels.quantityNotAvailable"));
		}
        e.preventDefault();
  };

	decrement = (e) => {
		e.preventDefault();
		if(this.state.value <= 1){
			return this.state.value;
		}
		else{
			this.setState(prevState => ({
				value: Number(prevState.value) - 1
			}), function(){
				this.props.updateQuantity(this.state.value);
			});
		}
	};

	feed = (e) => {
		this.setState({
			value: this.refs.feedQty.value
		}, function(){
				this.props.updateQuantity(this.state.value);
		})
	};

	resetQuantity = () => {
		this.setState({
			value: 1
		})
	}

	render() {
		return (
			<div className="stepper-input">
				<a href="javascript:void(0)" className="decrement" onClick={this.decrement}>–</a>
				<input ref="feedQty"
					   readOnly={true}
					   type="number"
					   className="quantity"
					   value={this.state.value}
					   onChange={this.feed} />
				<a href="javascript:void(0)" className="increment" onClick={this.increment}>+</a>
			</div>
		)
	}
}

Counter.propTypes = {
  value: PropTypes.number
};

export default Counter;


// WEBPACK FOOTER //
// ./src/components/Counter.js